import ApolloClient, {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-boost";
import { Auth } from "aws-amplify";
import gql from "graphql-tag";

async function getCurrentToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}

async function getPossibleTypes(uri, token) {
  const response = await fetch(uri, {
    method: "POST",
    headers: { "Content-Type": "application/json", authorization: token },
    body: JSON.stringify({
      variables: {},
      query: `
        query introspectionQueryResultData
          {
            __schema {
              types {
                kind
                name
                possibleTypes {
                  name
                }
              }
            }
          }
        `,
    }),
  }).then((result) => result.json());

  return response.data;
}

async function createGqlClient(uri, { addTypename = true } = {}) {
  const token = await getCurrentToken();
  const introspectionQueryResultData = await getPossibleTypes(uri, token);
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
  });
  const cache = new InMemoryCache({ fragmentMatcher, addTypename });

  return new ApolloClient({
    uri,
    cache,
    request: async (operation) => {
      operation.setContext({
        headers: {
          authorization: await getCurrentToken(),
        },
      });
    },
  });
}

const messagingApiUri = import.meta.env.VITE_APP_API_UNIVERSAL_URI;
let client = null;

async function getClient() {
  if (!client) client = await createGqlClient(messagingApiUri);

  return client;
}

export async function getReceivedMessages({
  nextKey = null,
  limit = 5,
  dateSentAfter = null,
  isAssumingUser = null,
}) {
  const client = await getClient();

  const input = {
    pagination: {
      nextKey,
      limit,
    },
    filters: {
      dateSentAfter,
    },
    assumedUserId: isAssumingUser,
  };

  return client.query({
    fetchPolicy: "network-only",
    variables: { input },
    query: gql`
      query receivedMessages(
        $input: ReceivedMessagesInput!
        $resource: Resource = messaging
      ) {
        receivedMessages(input: $input, resource: $resource) {
          __typename
          ... on ReceivedMessagesResult {
            user {
              unreadMessageCount
            }
            nextKey
          }
          ... on Error {
            errorMessage
          }
        }
      }
    `,
  });
}